module.exports = __webpack_public_path__ + "static/img/hr.4680d632.svg";